
import {
  DxDataGrid,
  DxEditing,
  DxColumn,
  DxValidationRule,

  DxPaging,
  DxForm,
  DxFilterRow,
  DxSearchPanel,
  DxScrolling,
  DxPager,
  DxSelection
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import MultaTemaService from '../services/multatema-service';


import Cookies from "js-cookie";
window.Cookies = Cookies;


export default {
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxValidationRule,
    DxPaging,

    DxForm,
    DxItem,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxSelection,
    DxToast,

  },
  data() {
    return {
      productos: null,
      dataSourceProducts: null,
      dataSourceBrands: null,
      dataSourceGroupProducts: null,
      allowedPageSizes: [5, 10, 20, 50, 'all'],
      showInfo: true,
      showNavButtons: true,
      isVisible: false,
      message: '',
      type: 'info',
      popupOptions: {
        title: 'Multa Tema',
        showTitle: true,
        width: 420,
        height: 230,
      },
      servicioService: null,
      labelMode: 'floating',
      labelLocation: 'left',
    };
  },
  created() {
    this.multatemaService = new MultaTemaService();

  },
  mounted() {
    this.loadDataInfo();
  },

  methods: {
    loadDataInfo() {
      this.multatemaService.getMultaTema().then(data => {
        this.dataSourceProducts = data;
      });
    },
    onSaved() {
      if (this.retryButtonVisible) {
        this.retryButtonVisible = false;
      }
    },
    onEditCanceled() {
      if (this.retryButtonVisible) {
        this.retryButtonVisible = false;
      }
    },

    editRegister(e) {



      let myJSON = JSON.stringify({
        pid: e.data.id,
        pdescripcion: e.data.descripcion,

      });



      this.multatemaService.updateMultaTema(myJSON).then(data => {

        if (data.err == 0) {
          this.type = 'success';
          this.message = 'Se ha actualizado el registro';
          this.isVisible = true;
          this.loadDataInfo();
        } else {

          this.type = 'error';
          this.message = 'Ocurrio un error ' + data.msg;
          this.isVisible = true;

        }


      });
    },
    deleteRegister(e) {
      let myJSON = JSON.stringify({
        pid: e.data.id,
      });


      this.multatemaService.deleteMultaTema(myJSON).then(data => {

        if (data.err == 0) {
          this.type = 'success';
          this.message = 'Se ha eliminado el registro';
          this.isVisible = true;
          this.loadDataInfo();
        } else {

          this.type = 'error';
          this.message = 'Ocurrio un error ' + data.msg;
          this.isVisible = true;

        }


      });

    },
    createRegister(e) {




      let myJSON = JSON.stringify({
        pdescripcion: e.data.descripcion,

      });



      this.multatemaService.createMultaTema(myJSON).then(data => {

        if (data.err == 0) {
          this.type = 'success';
          this.message = 'Se ha creado el registro';
          this.isVisible = true;

        } else {

          this.type = 'error';
          this.message = 'Ocurrio un error ' + data.msg;
          this.isVisible = true;

        }
        this.loadDataInfo();

      });


    },


  },
};
